/**
 * Holding Javiland — marcas (Gerencia 26 ago 2026).
 * Sin «javi» ni «land» en las marcas hijas.
 * pitch / highlights = copy público landings (sin menciones a agentes internos).
 */

export const HOLDING_BRAND_NAMES = {
  saludable: {
    id: 'saludable',
    name: 'Costal Campesino',
    menuLabel: 'Costal Campesino',
    provisional: false,
    role: 'store',
    tagline: 'Despensa honesta · secos y naturales',
    pitch:
      'Secos, cacao y recetas pensados para tu cocina real. Home, tienda y comunidad ya están abiertos.',
    highlights: ['Tienda live', 'Recetas A/B/C', 'Chía gratis · Envia'],
    status: 'live',
    hubPath: '/costal',
    menuPath: '/costal',
    storeUrl: '/costal',
    domainNote: 'Home live en javiland.com/costal',
    social: {
      instagram: 'https://www.instagram.com/costal.campesino/',
      facebook: '',
    },
    waitlistEmail: null,
  },
  ropa: {
    id: 'ropa',
    name: 'Órbita',
    menuLabel: 'Órbita',
    provisional: false,
    role: 'store',
    tagline: 'Prenda con presencia · conciencia artística',
    pitch:
      'Prenda con carácter para quien viste con intención. La marca propia está en construcción; mientras tanto hay puente en la tienda del holding.',
    highlights: ['Prenda con presencia', 'Ecosistema en construcción', 'Lista de espera'],
    status: 'proximamente',
    hubPath: '/proyectos/ropa',
    menuPath: '/proyectos/ropa',
    storeUrl: null,
    domainNote: 'Camisetas puente en /tienda · marca propia en construcción',
    social: {
      instagram: '',
      facebook: '',
    },
    waitlistEmail: 'studio@javiland.com',
  },
  bakata: {
    id: 'bakata',
    name: 'Bakata',
    menuLabel: 'Bakata',
    provisional: false,
    role: 'store',
    tagline: 'Cannabis / parafernalia legal · Colombia',
    pitch:
      'Un ecosistema legal y cuidadoso alrededor del cannabis en Colombia. Estamos armando el canal; dejá tu correo y te avisamos al abrir.',
    highlights: ['Colombia', 'Canal propio', 'Lista de espera'],
    status: 'proximamente',
    hubPath: '/proyectos/bakata',
    menuPath: '/proyectos/bakata',
    storeUrl: 'https://bakata.co',
    domainNote: 'bakata.co · en preparación',
    social: {
      instagram: '',
      facebook: '',
    },
    waitlistEmail: 'studio@javiland.com',
  },
  linaje: {
    id: 'linaje',
    name: 'Linaje',
    menuLabel: 'Linaje',
    provisional: false,
    role: 'store',
    tagline: 'Cacao artesanal · Carmen de Carupa',
    pitch:
      'Cacao artesanal desde Carmen de Carupa. Origen, sabor y una experiencia de compra directa — entrá a la landing y pedí por WhatsApp.',
    highlights: ['Cacao artesanal', 'Origen Carupa', 'Pedido directo'],
    status: 'live',
    hubPath: '/proyectos/linaje',
    menuPath: '/linaje',
    storeUrl: '/linaje',
    domainNote: 'Landing en javiland.com/linaje',
    social: {
      instagram: '',
      facebook: '',
    },
    waitlistEmail: null,
  },
  strutech: {
    id: 'strutech',
    name: 'Strutech Solutions',
    menuLabel: 'Strutech Solutions',
    provisional: false,
    role: 'store',
    tagline: 'Diseño y mobiliario · Bogotá',
    pitch:
      'Mobiliario y diseño con criterio para espacios que se viven. Explorá el ecosistema Strutech y descubrí Soft Seating y más.',
    highlights: ['Diseño Bogotá', 'Soft Seating', 'Sitio propio'],
    status: 'live',
    hubPath: '/proyectos/strutech',
    menuPath: '/proyectos/strutech',
    storeUrl: 'https://strutechsolutions.com/',
    domainNote: 'strutechsolutions.com',
    social: {
      instagram: '',
      facebook: '',
      linkedin: '',
    },
    waitlistEmail: null,
  },
  meridian: {
    id: 'meridian',
    name: 'Meridian',
    menuLabel: 'Meridian · tecnología',
    provisional: false,
    role: 'store',
    tagline: 'Tech de lujo · Apple · nómadas digitales',
    pitch:
      'Tech de lujo para vivir y trabajar en digital. Apple primero, nómadas e IA en el horizonte. Dejá tu correo: abrimos con método.',
    highlights: ['Tech de lujo', 'Apple first', 'Lista de espera'],
    status: 'proximamente',
    hubPath: '/proyectos/meridian',
    menuPath: '/proyectos/meridian',
    storeUrl: null,
    domainNote: 'Ecosistema en construcción',
    social: {
      instagram: '',
      facebook: '',
    },
    waitlistEmail: 'studio@javiland.com',
  },
  productStudio: {
    id: 'product-studio',
    name: 'Atelier',
    provisional: false,
    role: 'agency',
    tagline: 'Agencia de ecosistemas digitales',
    pitch:
      'Diseñamos, lanzamos y evolucionamos ecosistemas digitales para marcas que quieren crecer con método. Del concepto al canal operativo.',
    highlights: ['Ecosistemas digitales', 'Método por fases', 'studio@javiland.com'],
    status: 'live',
    hubPath: '/servicios/product-studio',
    storeUrl: null,
    domainNote: 'Canal principal · studio@javiland.com',
    social: {
      linkedin: '',
    },
    waitlistEmail: 'studio@javiland.com',
  },
  turismo: {
    id: 'turismo',
    name: 'Conoce Colombia',
    provisional: true,
    role: 'store',
    tagline: 'Turismo · post prioridad',
    pitch: 'Experiencias de territorio con criterio. Pronto en el menú del holding.',
    highlights: ['Turismo', 'Colombia', 'Pronto'],
    status: 'proximamente',
    hubPath: '/proyectos/turismo',
    menuPath: '/proyectos/turismo',
    storeUrl: null,
    domainNote: 'Fuera de menú hasta GO',
    social: {},
    waitlistEmail: 'studio@javiland.com',
  },
};

/** Menú Proyectos Digitales — Costal = tienda (sin ítem duplicado «Tienda naturales»). */
export const HOLDING_STORE_MENU = [
  HOLDING_BRAND_NAMES.saludable,
  HOLDING_BRAND_NAMES.ropa,
  HOLDING_BRAND_NAMES.bakata,
  HOLDING_BRAND_NAMES.linaje,
  HOLDING_BRAND_NAMES.strutech,
  HOLDING_BRAND_NAMES.meridian,
];

/** 1 estrella por marca en home hub */
export const HOLDING_STAR_PRODUCTS = [
  {
    brandId: 'saludable',
    title: 'Semillas de girasol',
    subtitle: 'Costal Campesino · tienda live',
    href: '/producto/30',
    image: '/images/placeholders/placeholder-product.png',
    status: 'live',
  },
  {
    brandId: 'ropa',
    title: 'Camiseta Temporada 2',
    subtitle: 'Puente Órbita · en tienda',
    href: '/producto/101',
    image: '/images/tienda/ropa/camiseta-t2-mockup-02-back.jpg',
    status: 'live',
  },
  {
    brandId: 'bakata',
    title: 'Bakata',
    subtitle: 'Ecosistema en construcción',
    href: '/proyectos/bakata',
    image: '/images/placeholders/placeholder-product.png',
    status: 'proximamente',
  },
  {
    brandId: 'linaje',
    title: 'Cacao Linaje',
    subtitle: 'Landing F1 live',
    href: '/linaje',
    image: '/images/tienda/costal/cacao-mesa-pastillitas-200g.jpg',
    status: 'live',
  },
  {
    brandId: 'strutech',
    title: 'Soft Seating',
    subtitle: 'Strutech Solutions',
    href: 'https://strutechsolutions.com/',
    image: '/images/placeholders/placeholder-product.png',
    status: 'live',
  },
  {
    brandId: 'meridian',
    title: 'Meridian',
    subtitle: 'Tech lujo · en construcción',
    href: '/proyectos/meridian',
    image: '/images/placeholders/placeholder-product.png',
    status: 'proximamente',
  },
];

export const SALUDABLE_SUPPLIER_CASCADE = ['Javiland', 'FrutSec', 'Himalaya'];

export const getBrandById = (id) =>
  Object.values(HOLDING_BRAND_NAMES).find((b) => b.id === id) || null;
